import React from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Box, Container, Paper } from "@mui/material";

import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import SkillInfoForm from "../../components/skillInfo/SkillInfoForm";
import FormContent, { buildSkillPayload } from "../../components/skillInfo/skillInfoFormSchema";
import { cloneRankValue, DEFAULT_RANK_VALUE } from "../../components/skillInfo/skillRankEdit";
import { postDataRequest } from "../../helper/AxiosHelper";

const rankSeed = cloneRankValue(DEFAULT_RANK_VALUE);

export default function Component() {
  const navigate = useNavigate();
  const formik = useFormik(FormContent.FormikInstance);

  const handleCreate = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setTouched(
        Object.keys(errors).reduce((touched, key) => ({ ...touched, [key]: true }), {})
      );
      toast.error("請檢查表單");
      return;
    }

    let payload;
    try {
      payload = buildSkillPayload(formik.values);
    } catch (error) {
      toast.error("輸入設定必須是 JSON");
      return;
    }

    postDataRequest("skillInfo/create", payload, (isSuccess, message, body) => {
      if (!isSuccess) {
        toast.error(typeof message === "string" && message ? message : "新增失敗");
        return;
      }
      toast.success("新增成功");
      const insertId = body?.result?.insert_id;
      setTimeout(() => {
        navigate(insertId ? `/skill_info/${insertId}` : "/skill_infos");
      }, 800);
    });
  };

  return (
    <Container maxWidth={"lg"}>
      <CommonBreadcrumb />
      <Box sx={{ mt: 3 }}>
        <Paper sx={{ px: 3, py: 5 }} elevation={3}>
          <SkillInfoForm
            formik={formik}
            rankSeed={rankSeed}
            onSubmit={handleCreate}
            submitLabel="新增"
          />
        </Paper>
      </Box>
    </Container>
  );
}
